module.exports = __webpack_public_path__ + "static/salon-3948b7fbee5125a4b63607eeebcabd8c.jpg";